import { useParams, Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import api from '../services/api'
import { getMediaUrl } from '../utils/media'
import { 
  ChevronLeft, 
  Calendar, 
  Building2, 
  Loader2,
  Image as ImageIcon
} from 'lucide-react'

const DetailSeminaire = () => {
  const { id } = useParams()

  const { data: seminaire, isLoading, error } = useQuery({
    queryKey: ['seminaire', id],
    queryFn: async () => {
      const res = await api.get(`/seminaires/${id}`)
      return res.data
    }
  })

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <Loader2 className="animate-spin text-cidh-blue mb-4" size={50} />
        <p className="text-gray-500 font-medium">Chargement des détails du séminaire...</p>
      </div>
    )
  }

  if (error || !seminaire) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">Oups ! Séminaire introuvable.</h2>
        <Link to="/projets" className="text-cidh-blue hover:underline flex items-center gap-2">
          <ChevronLeft size={20} /> Retour à la liste des projets
        </Link>
      </div>
    )
  }


  return (
    <div className="pt-32 pb-16 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <Link to="/projets" className="inline-flex items-center gap-2 text-cidh-blue mb-8 hover:translate-x-1 transition-transform font-semibold">
          <ChevronLeft size={20} /> Retour à la liste des projets
        </Link>

        {/* Fiche Séminaire en format Tableau */}
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200">
          <div className="pt-12 pb-8 px-8 border-b bg-gray-50">
             <h1 className="text-2xl font-bold text-cidh-blue leading-tight mb-2">
               SÉMINAIRE : {seminaire.titre}
             </h1>
          </div>

          <table className="w-full border-collapse text-sm md:text-base">
            <tbody>
              {/* Row 1 */}
              <tr>
                <td className="border p-6 w-1/2 align-top">
                  <span className="font-bold">Thème du Séminaire :</span> <br/>
                  <div className="mt-2 text-cidh-blue font-semibold">{seminaire.titre}</div>
                </td>
                <td className="border p-6 w-1/2 align-top">
                  <span className="font-bold">Date de réalisation :</span> <br/>
                  <div className="mt-2 text-cidh-gold font-bold">{seminaire.date_texte}</div>
                </td>
              </tr>

              {/* Row 2 */}
              <tr>
                <td className="border p-6 align-top">
                  <span className="font-bold">Entreprise / Organisme client :</span> <br/>
                  <div className="mt-2 flex items-center gap-2">
                    <Building2 size={18} className="text-cidh-blue" />
                    <span className="font-bold underline">{seminaire.entreprise}</span>
                  </div>
                </td>
                <td className="border p-6 align-top">
                  <span className="font-bold">Financement / Valeur (F CFA) :</span> <br/>
                  <div className="mt-2">
                    <span className="font-bold text-lg">{new Intl.NumberFormat('fr-FR').format(seminaire.financement_fcfa)} F CFA</span>
                  </div>
                </td>
              </tr>

              {/* Row 3 - Full width description placeholder if needed, otherwise empty */}
              <tr>
                <td colSpan="2" className="border p-6 align-top bg-gray-50/50 italic text-gray-500">
                  Séminaire de formation réalisé dans le cadre du renforcement des capacités pour le compte de {seminaire.entreprise}.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Album Photos */}
        {seminaire.images?.length > 0 && (
          <div className="mt-12 space-y-8">
            <h2 className="text-2xl font-bold text-cidh-blue flex items-center gap-3">
              <ImageIcon className="text-cidh-gold" size={28} />
              Photos du séminaire
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {seminaire.images.map((img, idx) => (
                <div key={idx} className="rounded-2xl overflow-hidden h-72 shadow-lg border border-gray-100 bg-gray-200">
                  <img 
                    src={getMediaUrl(img, 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=800')} 
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    alt={`Séminaire Photo ${idx + 1}`} 
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=800';
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default DetailSeminaire
